import type { IQueryProviderResult, IQueryServiceResult } from '../../../../modules/consumer/search/types';
import type { LocationSuggestionResult } from '../../../../modules/maps/locationAutocomplete';
import type { LocationRecord } from '../../../../store/Location.model';

export enum QueryResultType {
  Service = 0,
  Stylist = 1,
  Salon = 2,
  PopularService = 3,
  AlsoSearched = 4,
  Location = 5,
}

export type LocationObject = LocationRecord | LocationSuggestionResult;

export type IQuerySuggestionData = (
  IQueryProviderResult | IQueryServiceResult | LocationObject
);

export interface IQuerySuggestion {
  id: number | string;
  text: string;
  matchedSubstrings: number[] | [];
  section: QueryResultType;
  data: IQuerySuggestionData;
  testId?: string;
  subItems?: Omit<IQuerySuggestion, 'subItems'>[];
}

export interface IQuerySuggestionList {
  testId?: string;
  title: string;
  data: IQuerySuggestion[];
}

export type SearchSubmitter = (
  query: string,
  addressObject: {
    address: string;
    latitude: string | number;
    longitude: string | number;
    placeId: string;
  },
  slugged: {
    q: string;
    popover_source?: string;
    loc?: string;
    lat?: string;
    lon?: string;
  }) => void;
